import { useDispatch } from "react-redux";
import { AppDispatch } from "./store";

// NOTE: Define custom hook for dispatching thunk action
// https://react-redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
